module.exports = __webpack_public_path__ + "static/media/mama-burger2-dt-en.77feeb0c.jpg";